/* Pharma Hermetic content pages: concern finder, in-page section nav, stockist locator, click-to-load video.
   Vanilla, progressive (every page reads fine without it), respects prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.__phPages) return;
  window.__phPages = true;
  var d = document;
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };
  var smooth = reduced ? 'auto' : 'smooth';

  /* ---------------- concern finder ---------------- */
  $$('[data-cf]').forEach(function (cf) {
    var tabs = $$('[role="tab"]', cf), panels = $$('[role="tabpanel"]', cf);
    if (!tabs.length) return;
    cf.classList.add('cf-ready');
    var idx = function (t) { return tabs.indexOf(t); };
    function select(tab, opts) {
      opts = opts || {};
      tabs.forEach(function (t) { var on = t === tab; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p) {
        var on = p.id === tab.getAttribute('aria-controls');
        p.hidden = !on;
        if (on) {
          p.classList.remove('tab-in'); void p.offsetWidth; if (!reduced) p.classList.add('tab-in');
          $$('[data-reveal],[data-split]', p).forEach(function (r) { r.classList.add('is-in'); });
        }
      });
      if (opts.focus) tab.focus();
      if (opts.hash && history.replaceState) history.replaceState(null, '', '#' + tab.getAttribute('aria-controls'));
      if (opts.scroll) {
        var panel = d.getElementById(tab.getAttribute('aria-controls'));
        var r = panel.getBoundingClientRect();
        if (r.top > innerHeight * 0.72 || r.top < 0) panel.scrollIntoView({ behavior: smooth, block: 'start' });
      }
      var n = idx(tab);
      $$('[data-cf-prev]', cf).forEach(function (b) { b.disabled = n === 0; });
      $$('[data-cf-next]', cf).forEach(function (b) { b.disabled = n === tabs.length - 1; });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); select(t, { hash: true, scroll: innerWidth < 1000 }); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (e.key === 'Home') k = -i; if (e.key === 'End') k = tabs.length - 1 - i;
        if (k) { e.preventDefault(); select(tabs[(i + k + tabs.length) % tabs.length], { focus: true, hash: true }); }
      });
    });
    var step = function (dir) {
      var cur = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      var nx = tabs[idx(cur) + dir]; if (!nx) return;
      select(nx, { hash: true });
      var p = d.getElementById(nx.getAttribute('aria-controls'));
      var top = cf.getBoundingClientRect().top;
      if (top < 0) cf.scrollIntoView({ behavior: smooth, block: 'start' }); else if (p) p.scrollIntoView({ behavior: smooth, block: 'nearest' });
    };
    $$('[data-cf-prev]', cf).forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
    $$('[data-cf-next]', cf).forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
    var fromHash = location.hash && tabs.filter(function (t) { return '#' + t.getAttribute('aria-controls') === location.hash; })[0];
    select(fromHash || tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0]);
    if (fromHash) setTimeout(function () { cf.scrollIntoView({ behavior: 'auto', block: 'start' }); }, 60);
    // links elsewhere on the page that point at a concern panel
    $$('a[href^="#cf-"]').forEach(function (a) {
      if (cf.contains(a)) return;
      a.addEventListener('click', function (e) {
        var t = tabs.filter(function (x) { return '#' + x.getAttribute('aria-controls') === a.getAttribute('href'); })[0];
        if (!t) return; e.preventDefault(); select(t, { hash: true }); cf.scrollIntoView({ behavior: smooth, block: 'start' });
      });
    });
  });

  /* ---------------- in-page section nav (scroll spy) ---------------- */
  $$('[data-subnav]').forEach(function (nav) {
    var inner = $('.subnav-in', nav) || nav;
    var links = $$('a[href^="#"]', nav);
    var map = links.map(function (a) { return d.getElementById(a.getAttribute('href').slice(1)); });
    var current = null;
    function setCur(i) {
      if (i === current) return; current = i;
      links.forEach(function (a, j) { a.setAttribute('aria-current', i === j ? 'true' : 'false'); });
      var a = links[i]; if (!a) { inner.scrollTo({ left: 0, behavior: smooth }); return; }
      var target = a.offsetLeft - (inner.clientWidth - a.offsetWidth) / 2;
      inner.scrollTo({ left: Math.max(0, target), behavior: smooth });
    }
    function spy() {
      var line = innerHeight * 0.32, best = -1;
      map.forEach(function (s, i) { if (s && s.getBoundingClientRect().top <= line) best = i; });
      setCur(best);
      var stuck = nav.getBoundingClientRect().top <= parseFloat(getComputedStyle(nav).top) + 1;
      nav.classList.toggle('is-stuck', stuck && best > -1);
    }
    var tk = false;
    addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(function () { spy(); tk = false; }); } }, { passive: true });
    addEventListener('resize', spy);
    spy();
  });

  /* ---------------- carousels inside engine tabs: re-measure once a hidden panel is shown ---------------- */
  d.addEventListener('click', function (e) {
    if (!e.target.closest('[data-tabs] [role="tab"]')) return;
    requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
  });

  /* ---------------- click-to-load YouTube ---------------- */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-yt]'); if (!a) return;
    e.preventDefault();
    var core = $('.core', a) || a, id = a.getAttribute('data-yt');
    var f = d.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
    f.title = a.getAttribute('aria-label') || 'Video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen = true;
    core.appendChild(f);
    a.removeAttribute('data-yt'); a.removeAttribute('href'); a.setAttribute('role', 'presentation');
  });

  /* ---------------- stockist locator ---------------- */
  var LEAFLET_CSS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
  var LEAFLET_JS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
  var leafletP = null;
  function loadLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    if (leafletP) return leafletP;
    leafletP = new Promise(function (res, rej) {
      if (!$('link[data-leaflet]')) { var l = d.createElement('link'); l.rel = 'stylesheet'; l.href = LEAFLET_CSS; l.setAttribute('data-leaflet', ''); l.crossOrigin = ''; d.head.appendChild(l); }
      var s = d.createElement('script'); s.src = LEAFLET_JS; s.async = true; s.crossOrigin = '';
      s.onload = function () { window.L ? res(window.L) : rej(new Error('Leaflet missing')); };
      s.onerror = function () { leafletP = null; rej(new Error('Leaflet failed to load')); };
      d.head.appendChild(s);
    });
    return leafletP;
  }
  var PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21Z"/><circle cx="12" cy="9.5" r="2.5"/></svg>';
  function splitAddr(s) {
    s = String(s || '').replace(/\s+/g, ' ').trim();
    var i = s.indexOf(',');
    return i > 0 ? { name: s.slice(0, i).trim(), rest: s.slice(i + 1).trim() } : { name: s, rest: '' };
  }
  function haversine(a, b, c, e) {
    var R = 3958.8, r = Math.PI / 180, dl = (c - a) * r, dn = (e - b) * r;
    var h = Math.sin(dl / 2) * Math.sin(dl / 2) + Math.cos(a * r) * Math.cos(c * r) * Math.sin(dn / 2) * Math.sin(dn / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }

  $$('[data-locator]').forEach(function (box) {
    var src = box.getAttribute('data-src');
    var listEl = $('[data-loc-list]', box), countEl = $('[data-loc-count]', box), input = $('[data-loc-q]', box), nearBtn = $('[data-loc-near]', box), moreBtn = $('[data-loc-more]', box), mapEl = $('[data-loc-map]', box), statusEl = $('[data-loc-status]', box);
    var data = [], shown = [], limit = 0, map = null, markers = [], me = null, active = -1, q = '';
    var mobile = matchMedia('(max-width: 999px)');
    var PAGE = function () { return mobile.matches ? 12 : 9999; };

    function render() {
      var qq = norm(q);
      shown = data.filter(function (x) { return !qq || x.key.indexOf(qq) > -1; });
      if (me) shown = shown.slice().sort(function (a, b) { return a.dist - b.dist; });
      if (countEl) countEl.textContent = shown.length;
      var n = Math.min(shown.length, limit || PAGE());
      if (!shown.length) { listEl.innerHTML = '<li class="loc-empty">No matches</li>'; }
      else listEl.innerHTML = shown.slice(0, n).map(function (x) {
        return '<li><button type="button" data-i="' + x.i + '"' + (x.i === active ? ' aria-current="true"' : '') + '><span class="pin">' + PIN + '</span><span><b>' + esc(x.name) + '</b>' + (x.rest ? '<small>' + esc(x.rest) + '</small>' : '') + '</span>' + (me ? '<span class="dist">' + x.dist.toFixed(1) + ' mi</span>' : '<span></span>') + '</button></li>';
      }).join('');
      if (moreBtn) moreBtn.hidden = n >= shown.length;
      if (map) markers.forEach(function (m, i) { var vis = !qq || data[i].key.indexOf(qq) > -1; var on = map.hasLayer(m); if (vis && !on) m.addTo(map); if (!vis && on) map.removeLayer(m); });
    }
    function focusItem(i, fly) {
      active = i;
      $$('button[data-i]', listEl).forEach(function (b) { b.setAttribute('aria-current', +b.getAttribute('data-i') === i ? 'true' : 'false'); });
      markers.forEach(function (m, j) { var el = m.getElement && m.getElement(); if (el) { var dot = el.querySelector('.ph-dot'); if (dot) dot.classList.toggle('on', j === i); } });
      if (map && fly !== false) {
        var x = data[i];
        if (reduced) map.setView([x.lat, x.lng], 14); else map.flyTo([x.lat, x.lng], 14, { duration: 0.9 });
        markers[i].openPopup();
        if (mobile.matches) box.querySelector('.loc-map').scrollIntoView({ behavior: smooth, block: 'center' });
      }
    }
    function popup(x) {
      return '<b>' + esc(x.name) + '</b>' + (x.rest ? esc(x.rest) + '<br>' : '') + '<a href="https://www.google.com/maps/dir/?api=1&destination=' + x.lat + ',' + x.lng + '" target="_blank" rel="noopener">Directions</a>';
    }
    function initMap() {
      if (map || !mapEl) return;
      loadLeaflet().then(function (L) {
        if (map) return;
        var touch = matchMedia('(pointer: coarse)').matches;
        map = L.map(mapEl, { center: [52.4616, -2.0546], zoom: 6, scrollWheelZoom: false, dragging: !touch, tap: false, zoomControl: true, attributionControl: true });
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', maxZoom: 19, className: 'ph-tiles' }).addTo(map);
        var icon = L.divIcon({ className: '', html: '<div class="ph-dot"></div>', iconSize: [14, 14], iconAnchor: [7, 7], popupAnchor: [0, -8] });
        markers = data.map(function (x) {
          var m = L.marker([x.lat, x.lng], { icon: icon, title: x.name, keyboard: false }).bindPopup(popup(x));
          m.on('click', function () { focusItem(x.i, false); });
          return m.addTo(map);
        });
        if (touch) map.on('click', function () { map.dragging.enabled() || map.dragging.enable(); });
        box.classList.add('is-live');
        render();
      }).catch(function () { if (statusEl) statusEl.hidden = false; });
    }
    fetch(src, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (rows) {
      data = rows.filter(function (x) { return isFinite(x.lat) && isFinite(x.lng); }).map(function (x, i) {
        var a = splitAddr(x.title || x.address); if (x.title) a = { name: x.title, rest: x.address };
        return { i: i, name: a.name, rest: a.rest, lat: +x.lat, lng: +x.lng, key: norm((x.title || '') + ' ' + x.address), dist: 0 };
      });
      render();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); initMap(); } }, { rootMargin: '300px 0px' });
        io.observe(box);
      } else initMap();
    }).catch(function () { if (listEl) listEl.innerHTML = '<li class="loc-empty">Sorry, the list could not be loaded.</li>'; });

    listEl.addEventListener('click', function (e) { var b = e.target.closest('button[data-i]'); if (!b) return; initMap(); focusItem(+b.getAttribute('data-i')); });
    var t;
    if (input) input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { q = input.value; limit = 0; render(); }, 120); });
    if (input) input.form && input.form.addEventListener('submit', function (e) { e.preventDefault(); q = input.value; render(); var f = shown[0]; if (f) { initMap(); setTimeout(function () { focusItem(f.i); }, map ? 0 : 600); } });
    if (moreBtn) moreBtn.addEventListener('click', function () { limit = (limit || PAGE()) + 24; render(); });
    if (nearBtn) {
      if (!('geolocation' in navigator)) nearBtn.hidden = true;
      nearBtn.addEventListener('click', function () {
        if (nearBtn.disabled) return;
        nearBtn.disabled = true;
        nearBtn.classList.add('is-loading');
        navigator.geolocation.getCurrentPosition(function (pos) {
          var la = pos.coords.latitude, ln = pos.coords.longitude;
          data.forEach(function (x) { x.dist = haversine(la, ln, x.lat, x.lng); });
          me = { lat: la, lng: ln }; limit = 0; render();
          var closest = shown[0];
          initMap();
          var attempts = 0;
          var go = function () {
            if (!map) {
              if (++attempts < 50) return setTimeout(go, 200);
              if (statusEl) statusEl.hidden = false;
              nearBtn.disabled = false; nearBtn.classList.remove('is-loading');
              return;
            }
            nearBtn.disabled = false; nearBtn.classList.remove('is-loading');
            var L = window.L;
            if (box._me) map.removeLayer(box._me);
            box._me = L.marker([la, ln], { icon: L.divIcon({ className: '', html: '<div class="ph-me"></div>', iconSize: [16, 16], iconAnchor: [8, 8] }), keyboard: false }).addTo(map);
            if (closest) map.fitBounds(L.latLngBounds([[la, ln], [closest.lat, closest.lng]]).pad(0.6), { animate: !reduced, maxZoom: 13 });
          };
          go();
        }, function () {
          nearBtn.disabled = false; nearBtn.classList.remove('is-loading');
          if (window.toast) window.toast('Location unavailable', false);
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
      });
    }
    mobile.addEventListener && mobile.addEventListener('change', function () { limit = 0; render(); if (map) setTimeout(function () { map.invalidateSize(); }, 50); });
  });
})();
